import "./Focuss.scss";

const Focuss = () => {
  return (
    <div className="Focuss-box">
      {/* <p className="Focuss-text">
        Postanowiłem przygotować ten aż 11- modułowy kurs,
        <br /> który pomoże Ci gruntownie poznać temat wirtualizacji i
        wykorzystania Proxmoxa VE.
      </p>
      <p className="Focuss-focus">
        W 40% skupimy się na <span className="theory">części teoretycznej</span>
      </p>
      <p className="Focuss-focus">
        W 60% zajmiemy się <span className="configuration">konfiguracją</span>.
      </p> */}
      <p className="Focuss-text">
        <span className="supertheory">
          Sprawdzony kurs
          <br />w zaktualizowanej wersji!
        </span>
        <br />
        <br />
        To szkolenie ewoluuje razem z branżą! <br />
        <br />
        Kupując teraz, otrzymujesz{" "}
        <span className="theory">dostęp do wszystkich wersji.</span>
        <br />
        <br />
        Dzięki cennym sugestiom dotychczasowych kursantów oraz analizie trendów,
        wzbogaciłem program o najmocniej poszukiwane obecnie rozwiązania.
        <br />
        <br />
        <span className="theory">MailCow</span>
        <br />
        czyli własny serwer pocztowy
        <br />
        <br />
        <span className="theory">Proxmox VE</span>
        <br />
        jak wykorzystać to darmowe narzędzie
        <br />
        <br />
        <span className="theory">
          Nagranie z wdrożenia u Klienta z moim komentarzem
          <br />{" "}
        </span>
        czyli jak to wygląda w praktyce
        <br />
        <br />
        Nie zwlekaj, dołącz do grona osób, które zdobędą nowe, cenne
        umiejętności! <br />
        <br />
      </p>
    </div>
  );
};

export default Focuss;
